import JSONEditor from '@monaco-editor/react';
import type { VFC } from 'react';

interface JsonEditorFieldProps {
  value?: string | object;
  onChange?: (value: object) => void;
  isMagicRole?: boolean;
}

export const JsonEditorField: VFC<JsonEditorFieldProps> = ({ value, onChange, isMagicRole }) => {
  const stringValue = typeof value === 'object' && value !== null ? JSON.stringify(value, null, 2) : '';

  return (
    <JSONEditor
      defaultLanguage="json"
      height={400}
      options={{
        minimap: { enabled: false },
        readOnly: !isMagicRole,
      }}
      value={stringValue}
      onChange={newValue => {
        const parsedValue = newValue ? JSON.parse(newValue) : {};
        onChange?.(parsedValue);
      }}
    />
  );
};
